import { useState } from 'react';
import type { ReelClip } from '@/lib/sellerReel';

export function ProfileReel({ clips }: { clips: ReelClip[] }) {
  const [active, setActive] = useState(clips[0]?.id ?? null);
  const current = clips.find((c) => c.id === active) ?? clips[0];

  if (clips.length === 0 || !current) return null;

  return (
    <section className="mt-8">
      <p className="eyebrow mb-2">The work</p>
      <h2 className="font-display text-xl">Reel</h2>
      <video
        key={current.id}
        data-testid="public-reel"
        src={current.url}
        poster={current.poster}
        controls
        playsInline
        className="mt-3 max-h-[70vh] w-full rounded-xl bg-black object-cover"
      />
      {clips.length > 1 && (
        <div className="mt-3 flex gap-2 overflow-x-auto pb-1">
          {clips.map((clip, i) => (
            <button
              key={clip.id}
              type="button"
              onClick={() => setActive(clip.id)}
              className={`relative h-20 w-14 shrink-0 overflow-hidden rounded-lg border ${
                clip.id === current.id ? 'border-makhe-brand' : 'border-transparent'
              }`}
              aria-label={`Play clip ${i + 1}`}
            >
              {clip.poster ? (
                <img src={clip.poster} alt="" className="h-full w-full object-cover" />
              ) : (
                <span className="flex h-full w-full items-center justify-center bg-makhe-line/40 text-xs">
                  {i + 1}
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
